/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_User_LinkInputs */

const vi_grower_user_link = /** @type {(inputs: Grower_User_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản đăng nhập`)
};

/**

* @param {Grower_User_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_user_link = /** @type {((inputs?: Grower_User_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_User_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_user_link(inputs)
});